import { API } from 'utils/globalApiServices';
import { useQuery } from '@tanstack/react-query';

const queryFn = async ({ assignment_uuid, response_uuid, mode }) => {
  const url = `/roleplay/assignment-progress/${assignment_uuid}/scenario-response/${response_uuid}/?mode=${mode}`;
  const { graph_data } = await API.get(url);
  return graph_data || {};
};

const useGetAssignmentProgressGraphQuery = ({ assignment_uuid, response_uuid, mode }) => {
  return useQuery({
    queryFn: () => queryFn({ assignment_uuid, response_uuid, mode }),
    queryKey: ['ASSIGNMENT_PROGRESS_GRAPH', assignment_uuid, response_uuid, mode],
    enabled: !!assignment_uuid && !!response_uuid,
    onSuccess: (response) => {},
    onError: () => {},
  });
};

export default useGetAssignmentProgressGraphQuery;
